import React, { Component, Fragment } from "react";
import { withRouter , Link} from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import NumberFormat from 'react-number-format';
import { validaCamposNumericos } from "../../utils/formValidationUtil";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { ConfirmModal } from "../ConfirmModal/ConfirmModal";
import { ButtonBack } from "../Button/Back";
import SelectSearch from "../UI/SelectSearch/SelectSearch"
import { getMessagemErro } from "../../utils/erro";
import { TIPO_SOLICITACAO_ADESAO_INCLUSAO, TIPO_SOLICITACAO_ADESAO_ALTERACAO, ID_TIPO_SOLICITACAO_ADESAO_ALTERACAO } from "../../providers/constTiposSolicitacaoAdesao";
import { ID_SITUACAO_SOLICITACAO_REJEITADA_CEDENTE, ID_SITUACAO_SOLICITACAO_REJEITADA_GESTOR_PLATAFORMA } from "../../providers/constSituacoesSolicitacao";
import api from "../../services/api";
import './SolicitacaoAdesao.css';
import { SolicitacaoAdesaoAttachmentsAndHistory } from "./AttachmentsAndHistory";
import { FinalidadeSolicitacaoAdesao } from "../FinalidadeSolicitacaoAdesao/FinalidadeSolicitacaoAdesao";

const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

export const SolicitacaoAdesaoEdit =

withRouter(

// redux
connect(
	(null), 
	(mapDispatchToProps)
)(

	class extends Component {

		constructor(props){
			super(props);
			this.state = {
				solicitacao: {
					id: '',
					numero: '',
					orgao: '',
					fornecedora: '',
					tipo: '',
					nomeTipo: '',
					situacao: '',
					nomeSituacao: '',
					cpfDirigenteTi: '',
					cpfResponsavelTecnico: '',
					finalidade: '',
					justificativaAlteracaoVolumetria: '',
					volumetriaAtual: '',
					volumetriaSolicitada: '',
					alteracaoPermitida: true,
				},
				detalhesFornecedora: null,
				adesaoFornecedora: null,
				fornecedoras: [],
				dirigentesTi: [],
				responsaveisTecnicos: [],
				tiposSolicitacao: [TIPO_SOLICITACAO_ADESAO_INCLUSAO, TIPO_SOLICITACAO_ADESAO_ALTERACAO],
				textoPadraoFinalidade: '',
				carregandoFornecedoras: false,
				carregandoDirigentesTi: false,
				carregandoResponsaveisTecnicos: false,
				carregandoDetalhesFornecedora: false,
				carregandoAdesaoFornecedora: false,
				exibeModalModeloFinalidade: false,
				exibeModalInstrucao: false,
				exibeModalLiberaracaoAssinatura : false,
				botoesHabilitados : true,
				dataHoraCarregamentoPagina: new Date(),
				keyFinalidade: new Date(),
			};
			this.handleInputChange = this.handleInputChange.bind(this);
			this.handleInputNumberChange = this.handleInputNumberChange.bind(this);
			this.handleFornecedoraChange = this.handleFornecedoraChange.bind(this);
			this.carregarDirigentesTi = this.carregarDirigentesTi.bind(this);
			this.carregarResponsaveisTecnicos = this.carregarResponsaveisTecnicos.bind(this);
			this.carregaFornecedorasDisponiveisAdesao = this.carregaFornecedorasDisponiveisAdesao.bind(this);
			this.salvar = this.salvar.bind(this);
			this.novo = this.novo.bind(this);
			this.onChangeProperties = this.onChangeProperties.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />
					<div style={{margin: "10px"}}>
						<h1>Solicitação de Adesão a API e Alteração de Volumetria dos Órgãos</h1>
					</div>
					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			const id = this.props.match.params.id;

			if(id){
				api.get(`/api/solicitacao-adesao/${id}`)
					.then(response => { 
						const solicitacao = response.data;
						this.setState({ solicitacao }) 
						this.carregarDirigentesTi();
						this.carregarResponsaveisTecnicos();
						this.carregaInformacoesFornecedora(solicitacao.fornecedora);
					})
					.catch(erro => {
						const msg = getMessagemErro("Não foi possível recuperar a solicitação de adesão.", erro);
						console.log(JSON.stringify(msg));
						this.props.exibeMensagemErro(msg.mensagem, msg.erros);
					});
			} else {
				this.carregarDirigentesTi();
				this.carregarResponsaveisTecnicos();
			}

			this.setState({
				carregandoFornecedoras: true,
			})
			this.carregaFornecedorasDisponiveisAdesao();
		}

		renderForm() {
			const { solicitacao, detalhesFornecedora, adesaoFornecedora, keyFinalidade } = this.state;

			return(
				<div className="container-fluid">

					<ConfirmModal titulo="Confirmação" 
						visible={this.state.exibeModalLiberaracaoAssinatura}
						handleOk={(e) => this.salvar(e, true)}
						handleCancel={() => this.setState({exibeModalLiberaracaoAssinatura: false})}
						message="Deseja realmente liberar a solicitação para assinatura?<br/><br/>Certifique-se de que o campo Finalidade está preenchido corretamente, seguindo as instruções disponíveis na seção de ajuda desse campo. Caso contrário, sua solicitação <b>poderá ser recusada</b>."/>

					<div className="br-form">
						{ solicitacao.id &&
							<div className="row">
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label>Número:</label>
											<input value={solicitacao.numero} readOnly/>
										</div>
									</div>
								</div>
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label>Situação:</label>
											<input value={solicitacao.nomeSituacao} readOnly/>
										</div>
									</div>
								</div>
							</div>
						}
						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>API Necessária:</label>
										{ this.state.fornecedoras.length > 0 && 
											<SelectSearch
												id="fornecedora"
												name="fornecedora"
												options={this.state.fornecedoras.map(fornecedora => ({ value: fornecedora.id, label: fornecedora.nome }))}
												onChange={this.handleFornecedoraChange}
												value={solicitacao.fornecedora}
												disabled={solicitacao.id}
											/>
											}
											{ this.state.carregandoFornecedoras === true  && 
												<button className="br-button is-secondary is-circle is-loading" type="button"/>
											}
										{this.state.carregandoFornecedoras === false && this.state.fornecedoras.length === 0 && "Não há API's disponíveis para adesão."}
									</div>
								</div>
							</div>

							{solicitacao.fornecedora &&
								<Fragment>
									<div className="col-md">
										<div className="field">
											<div className="input">
												<label>Órgão cedente dos dados:</label>
												{detalhesFornecedora &&
													<input value={detalhesFornecedora.nomeOrgao} className="input-bold" readOnly/>
												}
												{ this.state.carregandoDetalhesFornecedora === true  && 
													<button className="br-button is-secondary is-circle is-loading" type="button"/>
												}
											</div>
										</div>
									</div>
									{ detalhesFornecedora && detalhesFornecedora.descricaoComplementar && 
										<div className="col-md">
											<div className="field">
												<div className="input">
													<label>Descrição da API:</label>
													<textarea value={detalhesFornecedora.descricaoComplementar} className="input-bold" readOnly={true} style={{height:"90px"}}/>
												</div>
											</div>
										</div>
									}
								</Fragment>
							}
						</div>
						{solicitacao.fornecedora &&
							<Fragment>
								<div className="row">
									<div className="col-md">
										<div className="field">
											<div className="input">
												<label>Dirigente de TI:</label>
												{ this.state.dirigentesTi.length > 0 && 
													<SelectSearch
														id="cpfDirigenteTi"
														name="cpfDirigenteTi"
														options={this.state.dirigentesTi.map(dirigenteTi => ({ value: dirigenteTi.cpf, label: `${dirigenteTi.cpf} - ${dirigenteTi.nome}` }))}
														onChange={this.handleInputChange}
														value={solicitacao.cpfDirigenteTi}
													/>
												}
												{this.state.carregandoDirigentesTi === true && 
													<button className="br-button is-secondary is-circle is-loading" type="button"/>
												}
												{this.state.carregandoDirigentesTi === false && this.state.dirigentesTi.length === 0 && "Não há dirigentes de TI cadastrados no órgão."}
											</div>
										</div>
									</div>
									<div className="col-md">
										<div className="field">
											<div className="input">
												<label>Responsável Técnico:</label>
												{ this.state.responsaveisTecnicos.length > 0 && 
													<SelectSearch
														id="cpfResponsavelTecnico"
														name="cpfResponsavelTecnico"
														options={this.state.responsaveisTecnicos.map(responsavelTecnico => ({ value: responsavelTecnico.cpf, label: `${responsavelTecnico.cpf} - ${responsavelTecnico.nome}` }))}
														onChange={this.handleInputChange}
														value={solicitacao.cpfResponsavelTecnico}	
													/>
												}
												{this.state.carregandoResponsaveisTecnicos === true && 
													<button className="br-button is-secondary is-circle is-loading" type="button"/>
												}
												{this.state.carregandoResponsaveisTecnicos === false && this.state.responsaveisTecnicos.length === 0 && "Não há responsáveis técnicos cadastrados no órgão."}
											</div>
										</div>
									</div>
								</div>

								<div className="row">
									<div className="col-sm-2">
										<div className="field">
											<div className="input">
												<label>Tipo de Solicitação:</label>
												{solicitacao.tipo && 
													<input value={solicitacao.nomeTipo} readOnly/>
												}
												{ this.state.carregandoAdesaoFornecedora === true && 
													<button className="br-button is-secondary is-circle is-loading" type="button"/>
												}
											</div>
										</div>
									</div>
									{adesaoFornecedora && solicitacao.volumetriaAtual > 0 &&
										<div className="col-sm-2">
											<div className="field">
												<div className="input">
													<label>Volumetria Atual:</label>
													<NumberFormat value={solicitacao.volumetriaAtual} 
														thousandSeparator={'.'} 
														decimalSeparator={','} 
														decimalScale={0}
														allowNegative={false}
														isNumericString={true}
														className="texto-alinhado-direita"
														readOnly
														/>
												</div>
											</div>
										</div>
									}
									<div className="col-sm-2">
										<div className="field">
											<div className="input">
												<label>Volumetria Anual Solicitada:</label>
												<NumberFormat value={solicitacao.volumetriaSolicitada} 
													thousandSeparator={'.'} 
													decimalSeparator={','} 
													decimalScale={0}
													allowNegative={false}
													isNumericString={true}
													className="texto-alinhado-direita"
													onValueChange={(valoresInput) => this.handleInputNumberChange('volumetriaSolicitada', valoresInput)}
													/>
											</div>
										</div>
									</div>
								</div>

								{solicitacao.tipo === ID_TIPO_SOLICITACAO_ADESAO_ALTERACAO &&
									<div className="row">
										<div className="col-md">  
											<div className="field">
												<div className="input"> 
													<label htmlFor="justificativaAlteracaoVolumetria">
														Justificativa para alteração de volumetria:
													</label>
													<textarea name="justificativaAlteracaoVolumetria" value={solicitacao.justificativaAlteracaoVolumetria} onChange={this.handleInputChange} maxLength={500} style={{height:"300px"}}/>
												</div>
											</div>
										</div>
									</div>
								}

								<FinalidadeSolicitacaoAdesao solicitacao={solicitacao} onChangeProperties={this.onChangeProperties} keyFinalidade={keyFinalidade}/>

								{ Number(solicitacao.situacao) === ID_SITUACAO_SOLICITACAO_REJEITADA_CEDENTE &&
									<div className="row">
										<div className="col-md">
											<div className="field">
												<div className="input">
													<label>Justificativa do cedente dos dados:</label>
													<textarea value={solicitacao.justificativaOrgaoFornecedor} readOnly={true} style={{height:"90px"}}/>
												</div>
											</div>
										</div>
									</div> 
								}

								{ Number(solicitacao.situacao) === ID_SITUACAO_SOLICITACAO_REJEITADA_GESTOR_PLATAFORMA &&
									<div className="row">
										<div className="col-md">
											<div className="field">
												<div className="input">
													<label>Justificativa conecta:</label>
													<textarea value={solicitacao.justificativaOrgaoAdministrador} readOnly={true} style={{height:"90px"}}/>
												</div>
											</div>
										</div>
									</div> 
								}

								{solicitacao.id &&
									<SolicitacaoAdesaoAttachmentsAndHistory solicitacao={solicitacao} habilitaEdicaoAnexo={true} keyHistory={this.state.dataHoraCarregamentoPagina}/>
								}

								{! solicitacao.id && 
									<div className="row">
										<div className="col-md">
											<span style={{color: '#C9302C'}}>
											* Os anexos ficarão disponíveis para download e upload após a inclusão da solicitação. 
											</span>
										</div>
									</div> 
								}
							</Fragment>
						}

						{/* button actions */}
						<div className="actions-button">
							<div className="actions justify-content-start">
								{this.state.solicitacao.alteracaoPermitida && 
									<button type="button" className="button is-primary" onClick={(e) => this.salvar(e, false)} disabled={!this.state.botoesHabilitados}>{solicitacao.id ? 'Alterar' : 'Incluir'}</button>
								}

								{solicitacao.liberacaoAssinaturaPermitida &&
									<button type="button" className="button is-secondary" onClick={() => this.setState({exibeModalLiberaracaoAssinatura: true})} disabled={!this.state.botoesHabilitados}>Liberar para Assinatura</button>
								}	

								{this.state.solicitacao.assinaturaPermitida && 
									<Link to={`/solicitacao-adesao/sign/${solicitacao.id}`}>
										<button type="button" className="button is-secondary botaoNovo" onClick={this.assinar} disabled={!this.state.botoesHabilitados}>Assinar</button>
										</Link>
								}

								{this.state.solicitacao.id && 
									<button type="button" className="button is-secondary botaoNovo" onClick={this.novo} disabled={!this.state.botoesHabilitados}>Nova Solicitação</button>
								}

								<ButtonBack disabled={!this.state.botoesHabilitados} />
							</div>
						</div>
					</div>
				</div>
				
			);
		}

		validaFormulario(){
			const limiteVolumetria = 2147483647;

			let mensagens = [];
			const { solicitacao } = this.state;
			const { fornecedora, cpfDirigenteTi, cpfResponsavelTecnico, tipo, volumetriaSolicitada, finalidade, justificativaAlteracaoVolumetria } = solicitacao;

			if(!fornecedora){
				mensagens.push({mensagem: "API necessária é obrigatória."})
			} else {

				if(!cpfDirigenteTi){
					mensagens.push({mensagem: "Dirigente de TI obrigatório."})
				}

				if(!cpfResponsavelTecnico){
					mensagens.push({mensagem: "Responsável técnico é obrigatório."})
				}

				if(!tipo){
					mensagens.push({mensagem: "Tipo de solicitação é obrigatório."})
				} else {
					if(tipo === ID_TIPO_SOLICITACAO_ADESAO_ALTERACAO && (!justificativaAlteracaoVolumetria || justificativaAlteracaoVolumetria.trim().length === 0)){
						mensagens.push({mensagem: "Justificativa para alteração de volumetria é obrigatória."})
					}
				}

				validaCamposNumericos(mensagens, volumetriaSolicitada, "Volumetria anual solicitada", true, false, true, limiteVolumetria);

				if(!finalidade || finalidade.trim().length === 0 ){
					mensagens.push({mensagem: "Finalidade é obrigatória."})
				}
			}
		
			if(mensagens.length > 0){
				this.props.exibeMensagemErro("Não foi possível realizar a operação porque há inconsistências nos campos informados:", mensagens)
				throw new Error("Formulário não preenchido corretamente.");
			}
		}

		onChangeProperties(nome, valor){
			const solicitacao = this.state.solicitacao;
			solicitacao[nome] = valor;
			this.setState({ solicitacao, keyFinalidade: new Date() });
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;

			const solicitacao = this.state.solicitacao;
			solicitacao[nome] = valor;
			this.setState({ solicitacao });
		}

		handleFornecedoraChange(evento){
			const fornecedora = evento.target.value;
			const { solicitacao }  = this.state;
			solicitacao.fornecedora = fornecedora;
			solicitacao.tipo = '';
			solicitacao.nomeTipo = '';
			solicitacao.finalidade = '';
			solicitacao.justificativaAlteracaoVolumetria = '';
			this.setState({ solicitacao });
			this.carregaInformacoesFornecedora(fornecedora);
		}

		handleInputNumberChange(nomePropriedade, valoresInput){
			const solicitacao = this.state.solicitacao;
			solicitacao[nomePropriedade] = Number(valoresInput.value);
			this.setState({ solicitacao });
		}

		carregaFornecedorasDisponiveisAdesao() {
			api.get('/api/aplicacao-fornecedora/disponivel-adesao-orgao')
				.then(response => { 
					this.setState({fornecedoras: response.data }) 
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar as API's.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.finally(() => {
					this.setState({carregandoFornecedoras : false});
				});
		}

		carregaInformacoesFornecedora(fornecedora) {
			this.setState({detalhesFornecedora: null, adesaoFornecedora: null});
			if(fornecedora) {
				this.setState({carregandoDetalhesFornecedora: true, carregandoAdesaoFornecedora: true});
				api.get(`/api/aplicacao-fornecedora/informacoes-complementares/${fornecedora}`)
					.then(response => { 
						this.setState({detalhesFornecedora: response.data});
					})
					.catch(erro => {
						const msg = getMessagemErro("Não foi possível recuperar os detalhes da API.", erro);
						console.log(JSON.stringify(msg));
						this.props.exibeMensagemErro(msg.mensagem, msg.erros);
					})
					.finally(()=> {
						this.setState({carregandoDetalhesFornecedora: false})
					});

				api.get(`/api/orgao/adesao/fornecedora/${fornecedora}`)
					.then(response => { 
						const adesaoFornecedora = response.data;
						const solicitacao = this.state.solicitacao;
						solicitacao.tipo = TIPO_SOLICITACAO_ADESAO_ALTERACAO.codigo;
						solicitacao.nomeTipo = TIPO_SOLICITACAO_ADESAO_ALTERACAO.nome;
						solicitacao.volumetriaAtual = adesaoFornecedora.limite;
						if(! solicitacao.id) {
							solicitacao.finalidade = adesaoFornecedora.finalidade;
						} 
						this.setState({adesaoFornecedora: response.data, solicitacao});
					})
					.catch(erro => {
						if(erro.status === 404) {
							const adesaoFornecedora = {}
							const solicitacao = this.state.solicitacao;
							solicitacao.tipo = TIPO_SOLICITACAO_ADESAO_INCLUSAO.codigo;
							solicitacao.nomeTipo = TIPO_SOLICITACAO_ADESAO_INCLUSAO.nome;
							solicitacao.volumetriaAtual = 0;
							if(! solicitacao.id) {
								solicitacao.finalidade = this.state.textoPadraoFinalidade;
							}
							this.setState({adesaoFornecedora, solicitacao});
						} else {
							const msg = getMessagemErro("Não foi possível recuperar a adesão do órgão para a API.", erro);
							console.log(JSON.stringify(msg));
							this.props.exibeMensagemErro(msg.mensagem, msg.erros);
						}
					})
					.finally(()=> {
						this.setState({carregandoAdesaoFornecedora: false})
					});
			}
		}

		carregarDirigentesTi() {
			this.setState({
				carregandoDirigentesTi: true,
			});
			api.get('/api/gestor/dirigente-ti')
				.then(response => { 
					const dirigentesTi = response.data;
					const solicitacao = this.state.solicitacao;
					if (dirigentesTi.length === 1){
						solicitacao.cpfDirigenteTi = dirigentesTi[0].cpf
					}

					this.setState({dirigentesTi, solicitacao }) 
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar os dirigentes de TI.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				}).finally(() => {
					this.setState({carregandoDirigentesTi : false});
				});
		}

		carregarResponsaveisTecnicos() {
			this.setState({
				carregandoResponsaveisTecnicos: true,
			});
			api.get('/api/gestor/responsavel-tecnico')
				.then(response => { 
					this.setState({responsaveisTecnicos: response.data }) 
					const responsaveisTecnicos = response.data;
					const solicitacao = this.state.solicitacao;
					if (responsaveisTecnicos.length === 1){
						solicitacao.cpfResponsavelTecnico = responsaveisTecnicos[0].cpf
					}

					this.setState({ responsaveisTecnicos, solicitacao })
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar os responsáveis técnicos.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				}).finally(() => {
					this.setState({carregandoResponsaveisTecnicos : false});
				});
		}

		novo(e){
			const rotaParaNovo = "/solicitacao-adesao/new";
			if (rotaParaNovo === this.props.location.pathname) {
				this.props.history.push("/");
				this.props.history.goBack();
			} else {
				this.props.history.push(rotaParaNovo);
			}
		}

		salvar (e, liberarParaAssinatura){
			this.props.limpaMensagem();
			this.setState({exibeModalLiberaracaoAssinatura : false});

			const { solicitacao } = this.state;

			try{
				this.validaFormulario();
			}catch(erroValidacao){
				e.preventDefault();
				return;
			}

			const method = solicitacao.id ? 'put' : 'post';
			let url = '/api/solicitacao-adesao';
			if(solicitacao.id){
				url = url + '/' + solicitacao.id;
			}

			solicitacao.liberarParaAssinatura = liberarParaAssinatura;

			const options = {
				method,
				url,
				data: solicitacao
			}

			this.props.mostraAguardando();
			this.setState({botoesHabilitados : false});
			api(options)
				.then(response => { 
					let operacao = 'incluída';
					if(this.state.solicitacao.id) {
						if(liberarParaAssinatura) {
							operacao = 'liberada para assinatura';
						} else {
							operacao = 'alterada';
						}
					}
					const mensagem = `Solicitação de adesão ${operacao} com sucesso!`;
					const solicitacao = response.data;
			
					this.setState({ 
						solicitacao,
						dataHoraCarregamentoPagina: new Date(),
					});
					this.props.exibeMensagemSucesso(mensagem);
				})
				.catch(erro => {
					const mensagemInicial = `Não foi possível ${this.state.solicitacao.id ? 'alterar' : 'incluir'} a solicitação de adesão.`;
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then(() => {
					this.props.escondeAguardando();
					this.setState({botoesHabilitados : true});
				});
		}
	
	}

) // redux
); // router